import { Switch } from "react-router-dom";

import ListagemSolicitacoes from "./Listagem";
import SolicitacaoCadastroDetalhes from "./Detalhes";

import AuthRoute from "ui/components/AuthRoute";

function SolicitacaoCadastroPages() {
  return (
    <Switch>
      <AuthRoute
        path="/administracao/solicitacao-cadastro"
        // permissions={["solicitacao-cadastro.listar"]}
        exact
        component={ListagemSolicitacoes}
      />
      <AuthRoute
        path="/administracao/solicitacao-cadastro/:id"
        component={SolicitacaoCadastroDetalhes}
      />
    </Switch>
  );
}

export default SolicitacaoCadastroPages;
